import React, { useState } from 'react';
import {
	TypingIndicatorWrapper,
	TypingIndicatorAvatarSlot,
	WaveIndicatorText,
	WaveIndicatorLetter,
} from './AIChat.Styled';

const LOADING_PHRASES = [
	'Thinking...',
	'Analyzing...',
	'Processing...',
	'Generating...',
	'Drafting your answer...',
	'Formulating...',
	'Pondering, stand by...',
];

export type AIChatWaveIndicatorProps = {
	assistantAvatarSrc?: string;
};

const DELAY = 60;

export function AIChatWaveIndicator({ assistantAvatarSrc }: AIChatWaveIndicatorProps): React.ReactElement {
	const [text] = useState(() => LOADING_PHRASES[Math.floor(Math.random() * LOADING_PHRASES.length)]);
	const showAvatar = Boolean(assistantAvatarSrc);
	return (
		<TypingIndicatorWrapper role="status" aria-label="Assistant is thinking">
			<TypingIndicatorAvatarSlot
				$visible={showAvatar}
				style={showAvatar ? { backgroundImage: `url(${assistantAvatarSrc})` } : undefined}
			/>
			<WaveIndicatorText>
				{text.split('').map((char, i) => (
					<WaveIndicatorLetter key={i} $delay={i * DELAY}>
						{char === ' ' ? ' ' : char}
					</WaveIndicatorLetter>
				))}
			</WaveIndicatorText>
		</TypingIndicatorWrapper>
	);
}
